/* eslint-disable import/prefer-default-export */
import { TFunction } from 'i18next';
import { listingItemtype } from 'types/ledger';
import { AccountingType } from 'v2-types/order';
import { sliceText } from 'views/orders/charges/components/GeneralChargesTable/utils';

export function formatEndorsmentDescription(code: string, description: string) {
  const endorsmentDescription = sliceText(description, 150);
  return `${code} - ${endorsmentDescription}`;
}

export const mapEndorsements = (
  endorsements: string[],
  options: listingItemtype[]
) => {
  return endorsements
    .map(endorsement => {
      const optionsDescription = options.find(({ code }) => endorsement === code)?.description ?? "";
      return ({
        code: endorsement,
        description: formatEndorsmentDescription(endorsement, optionsDescription),
        optionsDescription
      });
    });
};

export const validateAmountOverride = (accountingEntry: AccountingType) => (accountingEntry.amount_override > 0
  ? accountingEntry.amount_override
  : accountingEntry.amount);

export const getAmount = (accountingEntry: AccountingType | undefined) => (accountingEntry ? validateAmountOverride(accountingEntry) : 0);

export const LENDERS_ACTUAL = 'lenders_actual';
export const LENDERS_DISCLOSED = 'lenders_disclosed';
export const LENDERS_POLICY = 'lenders_policy';
export const LENDERS_TOTAL = 'lenders_total';
export const LENDERS_FEES = 'lenders_fees';
export const SUM_LENDERS_ENDORSEMENTS = 'lenders_endorsements';

export const OWNERS_ACTUAL = 'owners_actual';
export const OWNERS_DISCLOSED = 'owners_disclosed';
export const OWNERS_POLICY = 'owners_policy';
export const OWNERS_FEES = 'owners_fees';
export const SUM_OWNERS_ENDORSEMENTS = 'owners_endorsements';
export const RefinanceCredits = 'refinance_credits';
export const LendersPolicy = 'lenders_policy';
export const TX_GUARANTY_FEE = 'TX Guaranty Fee';

export const policyData = (
  t: TFunction,
  policy: number,
  sumEndorsement: number,
  fees: number
) => [
  {
    text: t('policyInfoAndRates:policy'),
    value: policy,
    plus: false,
    minus: false,
  },
  {
    text: t('policyInfoAndRates:endorsements'),
    value: sumEndorsement,
    plus: true,
    minus: false,
  },
  {
    text: t('policyInfoAndRates:fees-taxes'),
    value: fees,
    plus: true,
    minus: false,
  },
  {
    text: "Total",
    value: policy + sumEndorsement + fees,
    plus: false,
    minus: false,
  },
];

export const policyDataRefinance = ({
  t,
  lenderEndorsements,
  lenderFees,
  policy,
  credits,
  total
}: {
  t: TFunction,
  lenderEndorsements:number,
  lenderFees:number,
  policy: number,
  credits: number,
  total: number
}) => [
  {
    text: t('policyInfoAndRates:policy'),
    value: policy,
    plus: false,
    minus: false,
  },
  {
    text: `${t('orders:refinance')} ${t('policyInfoAndRates:credits')}`,
    value: credits,
    plus: false,
    minus: true,
  },
  {
    text: t('policyInfoAndRates:endorsements'),
    value: lenderEndorsements,
    plus: true,
    minus: false,
  },
  {
    text: t('policyInfoAndRates:fees-taxes'),
    value: lenderFees,
    plus: true,
    minus: false,
  },
  {
    text: t('policyInfoAndRates:total'),
    value: total,
    plus: false,
    minus: false,
  },
];
